import axios from "axios";

const channels = {
  email: {
    async send(payload) {
      const response = await axios.post("/v1/bill-delivery/send/email", {
        channel: "email",
        ...normalizePayload(payload),
      });
      return response.data;
    },
  },
  whatsapp: {
    async send(payload) {
      const response = await axios.post("/v1/bill-delivery/send/whatsapp", {
        channel: "whatsapp",
        ...normalizePayload(payload),
      });
      return response.data;
    },
  },
};

function normalizePayload(payload) {
  if (payload.document) return payload;

  const { document_title, bill_no, html, ...rest } = payload;
  // Server-rendered documents (sales) send no document at all.
  if (!html) return rest;
  return {
    ...rest,
    document: {
      document_title,
      bill_no,
      html,
    },
  };
}

export function canSendBillVia(channel) {
  return Boolean(channels[channel]);
}

export async function sendBillViaChannel(channel, payload) {
  const service = channels[channel];
  if (!service) throw new Error(`Unsupported bill delivery channel: ${channel}`);
  return service.send(payload);
}
